import CsTable from "./CsTable";
import CsDetails from "./CsDetails";
import CsChart from "./CsChart";
import CsForm, { CsFormLine, CsFormGroup } from "./CsForm";
import CsSimpleHeader from "./CsSimpleTable/header";
import CsSimpleSearch from "./CsSimpleTable/search";
import CsSimpleTable from "./CsSimpleTable/table";
import CsTableInput from "./CsTableInput";
import CsDialog from "./CsDialog";
import CsText from "./CsText";
import CsSearch from "./CsSearch";
import CsDatePicker from "./CsDatePicker";
import CsSpace from "./CsSpace";
import CsTypography from "./CsTypography";
import { debounceClick, tooltip, safeHtml } from "@/directive";
let plugins = {};
const componentArray = [
  CsChart,
  CsTable,
  CsDetails,
  CsForm,
  CsFormLine,
  CsFormGroup,
  CsSimpleHeader,
  CsSimpleSearch,
  CsSimpleTable,
  CsTableInput,
  CsText,
  CsSearch,
  CsDatePicker,
  CsSpace,
  CsTypography,
];
const install = function (Vue, opts = {}) {
  if (plugins.installed) return;
  plugins.installed = true;
  componentArray.forEach((item) => {
    Vue.component(item.name, item);
  });
  Vue.prototype.$COMMONUI = {
    components: opts.components || {},
    formOptions: opts.formOptions || {},
    shortcuts: opts.shortcuts || {},
  };
  Vue.prototype.$CsDialog = CsDialog;
  Vue.directive("debounce-click", debounceClick);
  Vue.directive("tooltip", tooltip);
  Vue.directive("safe-html", safeHtml);
};
export default {
  install,
  CsTableInput,
};
export { CsTableInput };
